/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023-2025 (original work) Open Assessment Technologies SA ;
 */
import config from '@/config';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard.js';
import { FEATURE_CUSTOM_REPORTS } from '@/constants/features.js';

export const routing = [
    {
        path: [config.routes.reports.widgetSandbox],
        controller: () => import('./controllers/widgetSandbox'),
        guard: getFeaturesGuard(FEATURE_CUSTOM_REPORTS)
    },
    {
        path: [config.routes.reports.customReports],
        controller: () => import('./controllers/customReports'),
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CUSTOM_REPORTS),
            getPermissionsGuard([{ resource: 'portal.custom-reports', scopes: ['view'] }])
        ])
    },
    {
        path: [config.routes.reports.report],
        controller: () => import('./controllers/report'),
        guard: getPermissionsGuard([
            { resource: 'portal.report', scopes: ['view'] },
            { resource: 'portal.session-report', scopes: ['view'] },
            { resource: 'portal.dashboard', scopes: ['view'] }
        ])
    }
];
